import { InvitationLayout } from '@shared/components/auth/InvitationLayout';
import { useLogout } from '@modules/Auth/hooks/useAuth';
import { Button } from '@shared/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@shared/components/ui/shadcn/alert';
import { useAuthStore } from '@shared/stores/authStore';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { AcceptInvitationForm } from '../components/AcceptInvitationForm';

const AcceptInvitationPage: React.FC = () => {
  const { t } = useTranslation('usersModule');
  const sessionToken = useAuthStore((state) => state.token);
  const sessionEmail = useAuthStore((state) => state.user?.email);
  const location = useLocation();
  const logout = useLogout(location.pathname + location.search + location.hash);

  return (
    <InvitationLayout
      welcomeTitle={t('acceptInvitation.welcome', '¡Bienvenido al equipo!')}
      welcomeDescription={t('acceptInvitation.welcomeDescription', 'Estás a un paso de unirte al equipo')}
    >
      <h1 className="text-2xl md:text-[28px] font-bold py-2 text-card-title">
        {t('acceptInvitation.title', 'Aceptar Invitación')}
      </h1>
      {sessionToken ? (
        <div className="space-y-4 pt-2">
          <Alert>
            <AlertTitle>{t('acceptInvitation.sessionConflict.title')}</AlertTitle>
            <AlertDescription className="space-y-3">
              {sessionEmail && (
                <p className="break-words font-medium">
                  {t('acceptInvitation.sessionConflict.currentAccount', { email: sessionEmail })}
                </p>
              )}
              <p>{t('acceptInvitation.sessionConflict.description')}</p>
              <p>{t('acceptInvitation.sessionConflict.privateWindow')}</p>
            </AlertDescription>
          </Alert>
          <Button fullWidth disabled={logout.isPending} onClick={() => logout.mutate()}>
            {logout.isPending && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
            {t(
              logout.isPending
                ? 'acceptInvitation.sessionConflict.loggingOut'
                : 'acceptInvitation.sessionConflict.logout',
            )}
          </Button>
          <Button asChild fullWidth variant="outline">
            <Link to="/">{t('acceptInvitation.sessionConflict.backToAccount')}</Link>
          </Button>
        </div>
      ) : (
        <>
          <p className="text-sm leading-relaxed pb-4">
            {t('acceptInvitation.description', 'Crea tu contraseña para unirte al equipo')}
          </p>
          <AcceptInvitationForm />
        </>
      )}
    </InvitationLayout>
  );
};

export default AcceptInvitationPage;
